/**
 * dictationCopy — the D9 lines the BROWSER can hit on its own.
 *
 * Most dictation notices come back from the server with the response, so there
 * is one wording and no mirror. These four the server never sees: a person
 * declining the browser's microphone prompt, a browser that cannot reach a
 * microphone at all, a request that never arrived, and a piece of audio with no
 * words in it. They are authored here so the surface always has something
 * honest to say.
 *
 * They are word-for-word the server's own lines (functions/src/prest0nSession/
 * voiceCopy.ts) and a parity test reads both files to keep them that way — the
 * CRA build cannot import from functions/, so a copy is the only option and a
 * gate is the price of it.
 *
 * D9: failure and refusal copy only. Never content.
 */

export type DictationCopyKey = 'mic-blocked' | 'mic-unavailable' | 'transcribe-failed' | 'no-speech';
export type DictationCopyLanguage = 'en' | 'es';

const EN: Readonly<Record<DictationCopyKey, string>> = {
  'mic-blocked': "this browser is blocking the microphone for prest0.ai. allow it in the address bar's site settings and press the microphone again.",
  'mic-unavailable': "this browser can't reach a microphone, so dictation isn't available here.",
  'transcribe-failed': "couldn't write that down just now. what you said is still in the box if the browser heard it — try again in a moment.",
  'no-speech': "didn't catch any words there.",
};

const ES: Readonly<Record<DictationCopyKey, string>> = {
  'mic-blocked': 'este navegador está bloqueando el micrófono para prest0.ai. permítelo en la configuración del sitio, en la barra de direcciones, y pulsa otra vez el micrófono.',
  'mic-unavailable': 'este navegador no puede acceder a un micrófono, así que el dictado no está disponible aquí.',
  'transcribe-failed': 'no se pudo escribir eso ahora mismo. lo que dijiste sigue en el cuadro si el navegador lo escuchó — inténtalo de nuevo en un instante.',
  'no-speech': 'no se escuchó ninguna palabra.',
};

export function dictationCopy(key: DictationCopyKey, language: DictationCopyLanguage = 'en'): string {
  return (language === 'es' ? ES : EN)[key];
}
